import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Handshake, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { BorrowerForm } from "@/components/BorrowerForm";

const POINTS = ["Independent, third-party feasibility analysis", "Market, site and financial projections with break-even and ROI", "Cash-flow projections organized so your lender can calculate DSCR", "PDF and Word delivery for your loan package"];

export default function ReferPage() {
  const { code } = useParams();
  const [p, setP] = useState(null);
  const [error, setError] = useState(false);
  const [tier, setTier] = useState("");
  useEffect(() => { api.get(`/public/partners/${code}`).then((r) => setP(r.data)).catch(() => setError(true)); }, [code]);
  if (error) return <div className="min-h-[60vh] grid place-items-center text-slate-400" data-testid="refer-not-found">This referral link is not valid.</div>;
  if (!p) return <div className="min-h-[60vh] grid place-items-center"><Loader2 className="h-6 w-6 animate-spin text-emerald-400" /></div>;
  const contact = [p.name, p.email || p.phone].filter(Boolean).join(" · ");
  return (
    <div className="grid-bg" data-testid="refer-page">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5 fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-cyan-500/40 bg-cyan-500/10 px-4 py-1.5 text-sm text-cyan-200 mb-6" data-testid="refer-badge"><Handshake className="h-4 w-4" />Referred by {p.name}{p.bank ? `, ${p.bank}` : ""}</span>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight leading-[1.05] mb-5">Your lender asked for a <span className="text-emerald-400">feasibility study</span>.</h1>
          <p className="text-slate-300 mb-8">{p.name} works with {p.company_name} for independent feasibility studies. Tell us about your project and we'll confirm scope, price and timing.</p>
          <ul className="space-y-3">{POINTS.map((x) => <li key={x} className="flex gap-3 text-sm text-slate-300"><ShieldCheck className="h-5 w-5 shrink-0 text-emerald-400" />{x}</li>)}</ul>
          <p className="text-xs text-slate-500 mt-6">A feasibility study supports your application. Loan approval is always the lender's decision.</p>
        </div>
        <div className="lg:col-span-7">
          <BorrowerForm tier={tier} setTier={setTier} refCode={p.code} initial={{ lender_name: p.bank || p.name, lender_contact: contact }} />
        </div>
      </div>
    </div>
  );
}
